// @flow
import * as React from 'react';
import { BaseSelect as SpeedBaseSelect } from 'speed-js-react-web';
import { withTheme } from 'styled-components';
import SelectMenuPlacementContext from 'esm-web-pro/contexts/SelectMenuPlacementContext';
import FormStylesContext from 'speed-js-react-web/src/context/FormStylesContext';


type Props = React.ElementConfig<SpeedBaseSelect>;

const Cmp = (props: Props) => {
    const { forwardedRef }: { forwardedRef: React.Ref } = props;
    const styles = React.useContext(FormStylesContext);
    return (
        <SelectMenuPlacementContext.Consumer>
            {(menuPlacementObject) => (
                <SpeedBaseSelect
                    ref={forwardedRef}
                    customStyle={styles}
                    {...props}
                    menuPlacement={menuPlacementObject ? menuPlacementObject.menuPlacement : 'auto'}
                    menuPortalTarget={menuPlacementObject
                        ? menuPlacementObject.menuPortalTarget
                        : document.querySelector('#root > div')}
                />
            )}
        </SelectMenuPlacementContext.Consumer>
    );
};

const BaseSelect = withTheme(Cmp);

export default React.forwardRef((props, ref) => (
    <BaseSelect {...props} forwardedRef={ref} />
));
